import React from 'react';
import classnames from 'classnames';
import Icons from 'components/icons';
import styles from './button-close.module.scss';

const ButtonClose = ({ children, className, ...rest }) => (
  <div className={classnames(styles.close, className)} {...rest}>
    <Icons name="cancel" fill="#333333" />
    <span>{children}</span>
  </div>
);

export default ButtonClose;
